export const INIT_USER = 'INIT_USER';
export const CHANGE_USER_SETTINGS = 'CHANGE_USER_SETTINGS';
export const UPLOAD_PLANS = 'UPLOAD_PLANS';
export const SHOW_LOADER = 'APP/SHOW_LOADER'
export const HIDE_LOADER = 'APP/HIDE_LOADER'
export const SHOW_BG_LOADER = 'APP/SHOW_BG_LOADER'
export const HIDE_BG_LOADER = 'APP/HIDE_BG_LOADER'
export const SHOW_ERROR = 'APP/SHOW_ERROR'
export const HIDE_ERROR = 'APP/HIDE_ERROR'
export const SHOW_MESSAGE = 'APP/SHOW_MESSAGE'
export const HIDE_MESSAGE = 'APP/HIDE_MESSAGE'
export const RERENDER_COMPONENT = 'APP/RERENDER_COMPONENT'
export const FETCH_MOVIES_SEARCH = 'MOVIE/FETCH_MOVIES_SEARCH'
export const UPLOAD_MOVIES_FAVORITE = 'MOVIE/UPLOAD_MOVIES_FAVORITE'
export const REMOVE_MOVIES_FAVORITE = 'MOVIE/REMOVE_MOVIES_FAVORITE'
export const FETCH_MOVIES_NOW_PLAYING = 'MOVIE/FETCH_MOVIES_NOW_PLAYING'
export const FETCH_MOVIES_POPULAR = 'MOVIE/FETCH_MOVIES_POPULAR'
export const FETCH_MOVIES_TOP_RATED = 'MOVIE/FETCH_MOVIES_TOP_RATED'
export const FETCH_MOVIES_UPCOMING = 'MOVIE/FETCH_MOVIES_UPCOMING'
export const FETCH_TV_TOP_RATED = 'TV/FETCH_TV_TOP_RATED'
export const FETCH_TV_POPULAR = 'TV/FETCH_TV_POPULAR'
export const FETCH_TV_SEASONS = 'TV/FETCH_TV_SEASONS'
export const FETCH_CONTENT_SEARCH_LIST = 'CONTENT/FETCH_CONTENT_SEARCH_LIST'
export const CLEAR_CONTENT_SEARCH_LIST = 'CONTENT/CLEAR_CONTENT_SEARCH_LIST'